<template>
  <div class="flex flex-row flex-wrap gap-x-xs gap-y-xs">
    <slot></slot>
  </div>
</template>
